/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  CompanyNotificationType,
  CompanyNotificationTypeFromJSON,
  CompanyNotificationTypeFromJSONTyped,
  CompanyNotificationTypeToJSON,
} from "./CompanyNotificationType";

/**
 *
 * @export
 * @interface AdminCompanyNotificationDto
 */
export interface AdminCompanyNotificationDto {
  /**
   *
   * @type {CompanyNotificationType}
   * @memberof AdminCompanyNotificationDto
   */
  type: CompanyNotificationType;
  /**
   *
   * @type {string}
   * @memberof AdminCompanyNotificationDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AdminCompanyNotificationDto
   */
  email: string;
}

export function AdminCompanyNotificationDtoFromJSON(json: any): AdminCompanyNotificationDto {
  return AdminCompanyNotificationDtoFromJSONTyped(json, false);
}

export function AdminCompanyNotificationDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AdminCompanyNotificationDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    type: CompanyNotificationTypeFromJSON(json["type"]),
    id: json["id"],
    email: json["email"],
  };
}

export function AdminCompanyNotificationDtoToJSON(value?: AdminCompanyNotificationDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    type: CompanyNotificationTypeToJSON(value.type),
    id: value.id,
    email: value.email,
  };
}
